import type { LexicalEditor } from "lexical";
import { create } from "zustand";

interface EditorInstanceState {
  editor: LexicalEditor | null;
  setEditor: (editor: LexicalEditor | null) => void;
}

/**
 * Holds the live LexicalEditor instance so non-Lexical surfaces (like
 * the share controller wired to the MainButton) can serialize the
 * current state without prop-drilling through the editor tree.
 */
export const useEditorInstance = create<EditorInstanceState>((set) => ({
  editor: null,
  setEditor: (editor) => {
    set({ editor });
  },
}));
